export default [
    {
        name: "公司简介",
        url: "#"
    },
    {
        name: "团队介绍",
        url: "#"
    },
    {
        name: "成功案例",
        url: "#"
    },
    {
        name: "定制服务",
        url: "#"
    },
    {
        name: "人才招聘",
        url: "#"
    },
    {
        name: "联系我们",
        url: "#"
    }
];
